export default __webpack_public_path__ + "static/media/CameraEditIcon.e5e8ccd2.svg";